import React from 'react';

import { HelpCircleFillIcon, Text } from '@thefarmersfront/kitchen';

import type { CustomHeaderGroupProps } from 'ag-grid-react';

import { useTooltipStore } from '~/store';

import styles from './TableHeaderWithTooltipIcon.module.scss';

type TypeTableHeaderWithTooltipIconProps = {
  /**
   * 헤더 타이틀 커스텀 컴포넌트
   * @description headerName 지정 외, 커스텀 컴포넌트 사용이 필요한 경우 사용
   */
  headerTitle?: React.ReactNode;
  tooltipDescription: React.ReactNode;
  tooltipTitle?: React.ReactNode;
  tooltipMaxWidth?: number;
} & CustomHeaderGroupProps;

/**
 * 테이블 헤더 커스텀 컴포넌트 (with 툴팁 아이콘)
 */
const TableHeaderWithTooltipIcon = ({
  headerTitle,
  tooltipDescription,
  tooltipTitle,
  tooltipMaxWidth,
  ...props
}: TypeTableHeaderWithTooltipIconProps) => {
  const { tooltip, setTooltip } = useTooltipStore();

  const handleMouseEnter = () => {
    setTooltip({
      show: true,
      description: tooltipDescription,
      title: tooltipTitle,
      maxWidth: tooltipMaxWidth,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, show: false });
  };

  return (
    <div className={styles['header-container']}>
      <Text className={styles['header-title']} size="large" weight="semi-bold">
        {headerTitle ?? props.displayName}
      </Text>
      <HelpCircleFillIcon
        className={styles['header-tooltip-icon']}
        size={16}
        color="gray400"
        data-tooltip-id="react-tooltip"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  );
};

export default TableHeaderWithTooltipIcon;
